// extracted by mini-css-extract-plugin
module.exports = {"header":"App_header__2L3DO","logo":"App_logo__2qPv-","userInfo":"App_userInfo__1K6tZ","content":"App_content__1Wt3K","footer":"App_footer__3csul"};